export const teams = {
  /**
   * @method GET list teams
   *
   * @method POST create team
   * @param {String} nome name of team
   * @param {String} id_lider identifier of leader team
   */
  teams: '/v2/api/aawz-partners/teams/',
  /**
   * @method GET list team permissions (co-leaders)
   * @method POST add co-leader to team
   * @param {Object} data { id_equipe, id_profissional, nivel_acesso }
   */
  permissions: '/v2/api/aawz-partners/permissoes-profissional-equipe',
  /**
   * @method DELETE remove co-leader from team
   * @param {String} id permission UUID
   */
  permissionById: (id) => `/v2/api/aawz-partners/permissoes-profissional-equipe/${id}`,
  /**
   * @method POST sync co-leaders for a team in batch
   * @param {Object} data { id_equipe: String (UUID), ids_profissionais: Array<Number> }
   */
  permissionsBatch: '/v2/api/aawz-partners/permissoes-profissional-equipe/batch',
}

export const bonus = {
  /**
   * @method GET list bonus
   *
   */
  list: `/v2/api/aawz-partners/bonus/goals/parameters-office/`,
  /**
   * @method POST list bonus
   *
   * @param {Array} data ex.: [{ "id": uuid,"name": "1","roa_min": null,"roa_max": 0.00350,"fator_bonus": 0.0}]
   */
  createUpdate: `/v2/api/aawz-partners/bonus/goals/parameters-office/`,
}

export const familyGroup = {
  /**
   * @method GET list family groups
   *
   * @method DELETE add in path /<uuid:id_grupo_familiar> to delete ex: /v2/api/aawz-partners/grupo-familiar/grupo-familiar/1
   *
   * @method PUT add in path /<uuid:id_grupo_familiar> to edit ex: /v2/api/aawz-partners/grupo-familiar/grupo-familiar/1
   *
   * @method POST create family groups
   * @param data {"nome": "teste"}
   *
   */
  family_group: `/v2/api/aawz-partners/grupo-familiar`,
  /**
   * @method PUT update origin calc family group
   *@param data {"maior_pl_grupo_familiar": true } or {"maior_pl_grupo_familiar": false }
   */
  originPl: '/v2/api/office/config/max-pl-family-group',
}

export const benchmarks = {
  /**
   * Gerenciar os benchmarks cadastrados para o escritorio (ou composição de benchmark).
   * @method GET Listar benchmarks
   *
   * @method POST Cadastrar nova composição de benchmark
   * @param {Array} data [{ indexador, taxa, ordem }]
   * Opcoes de indexados
   * @returns value: { nome, _composition }
   *
   * @method PUT Editar uma composição de benchmark
   * Mesma configuração do POST, porém com /:id na rota.
   *
   * @method DELETE Remover uma composição de benchmark.
   * @param {String} id na rota. /:id
   * @returns value: objeto removido.
   */
  list: '/v3/api/asset-allocation/benchmarks/config',
}

export const officeParametrization = {
  /**
   * @method GET list parameter office
   *
   * @method PUT create family groups
   * @param data {"roa_meta": "0.05","roa_atual": "0.05",}
   */
  officeParameters: '/v2/api/office/parametrization',

  /**
   * @method PUT Atualiza valor da periodicidade
   * @param data {"periodicidade_data_room_em_dias: 15"}
   */
  officeParametersPeriod: '/v2/api/office/parametrization',

  /**
   * @method GET Puxa todos os dados de periodicidade dos escritorios
   *
   */
  officePeriodsGet: '/v2/interno/api/admin/cs/data-room',
}

export const rubrics = {
  /**
   * @method GET list rubrics
   *
   * @method POST create rubric
   * @param data ex.: {"rubrica": "x"}
   *
   * @method Delete
   * @param data ex.: {"rubrica": "x"}
   * @param id  id of rubric
   *
   * @method PUT
   * @param id  id of rubric
   */
  rubric: `/v2/api/aawz-partners/bpo/ignored-rubrics`,
}

export const departments = {
  /**
   * @method GET get departments list
   */
  list: `/v3/api/aawz-partners/departments`,
  /**
   * @method POST
   * @param data
   *  @param nome
   *  @param tipo options: 'Produto' or 'Suporte'
   */
  add: `/v3/api/aawz-partners/departments`,
  /**
   * @method PUT
   * @param data
   *  @param nome
   *  @param tipo options: 'Produto' or 'Suporte'
   * @param id  id of the department
   */
  edit: (id) => `/v3/api/aawz-partners/departments/${id}`,
  /**
   * @method DELETE
   * @param id  id of the department
   */
  delete: (id) => `/v3/api/aawz-partners/departments/${id}`,
}

export const suitability = {
  /**
   * @method POST
   * @param file file with suitabilities
   */
  upload: '/v3/api/asset-allocation/suitability/import',
  /**
   * @method GET download file suitability
   */
  export: '/v3/api/asset-allocation/suitability/export',
}

export const permissionsAssessor = {
  /**
   * @method GET get permissions list
   * @method POST
   * @param data [{"id_profissional":1187, "funcionalidade":"settings", "possui_acesso":true}]
   */
  list: '/v2/professional-features/manage',
}

export const userModuleInfo = {
  /**
   * @method POST Send module of interest and origin of the click
   * @param module options: "financeiro", "juridico", "estrategia_performance" or "bi"
   * @param origin example: "CONFIGURAÇÕES > CONFIGURAÇÕES ESPECÍFICAS POR MÓDULOS"
   */
  upload: '',
}

export const repositoryFiles = {
  /**
   * @method GET list repository files
   *
   */
  files: `/v2/api/interno/aawz-data-room-interno/arquivos-publicos`,

  /**
   * @method GET download file repository
   * @param id  id of the file
   */
  download: (id) =>
    `/v2/api/interno/aawz-data-room-interno/file/${id}/download`,

  /**
   * @method POST envia o evento de download ou visualização do arquivo
   * @param id_arquivo  id do arquivo
   * @param evento opçoes: 'download' or 'visualizado'
   */
  sendEvent: `/v2/api/interno/aawz-data-room-interno/interno-data-room-eventos-profissional`,

  /**
   * @method GET
   * @param {Number} id id do arquivo
   */
  getComentarios:
    '/v2/api/interno/aawz-data-room-interno/interno-data-room-comentarios-profissional',

  /**
   * @method POST
   * @param id_arquivo
   * @param comentario
   * {"id_arquivo": "ca60127c-bb64-4439-8677-795894dcd7af", "comentario": "Comentario admin interno"}
   */
  sendComentario:
    '/v2/api/interno/aawz-data-room-interno/interno-data-room-comentarios-profissional',

  /**
   * @method POST
   * @param search Texto a ser procurado nos arquivos
   */
  getSearchAdvanced:
    '/v2/api/interno/aawz-data-room-interno/arquivos-publicos/search',
}

export const assetAllocation = {
  // #TODO: Atualizar rota
  /**
   * @method GET list asset types (mock)
   * Retorna a lista de tipos de ativos do escritório
   */
  types: '/mirror',
}

export const superRanking = {
  /**
   * @method GET list cycles
   * @method POST create cycle
   */
  cycles: '/super-ranking/cycles',
  /**
   * @method GET/PUT/DELETE single cycle
   * @param {String} id cycle UUID
   */
  cycle: (id) => `/super-ranking/cycles/${id}`,
  /**
   * @method POST execute ranking calculation for cycle
   * @param {String} id cycle UUID
   */
  cycleExecute: (id) => `/super-ranking/cycles/${id}/execute`,
  /**
   * @method GET list clusters
   * @method POST create cluster
   */
  clusters: '/super-ranking/clusters',
  /**
   * @method GET/PUT/DELETE single cluster
   * @param {String} id cluster UUID
   */
  cluster: (id) => `/super-ranking/clusters/${id}`,
  /**
   * @method GET list indicators
   * @method POST create indicator
   */
  indicators: '/super-ranking/indicators',
  /**
   * @method GET/PUT/DELETE single indicator
   * @param {String} id indicator UUID
   */
  indicator: (id) => `/super-ranking/indicators/${id}`,
  /**
   * @method GET list weights
   * @method POST create weight
   */
  weights: '/super-ranking/weights',
  /**
   * @method GET/PUT/DELETE single weight
   * @param {String} id weight UUID
   */
  weight: (id) => `/super-ranking/weights/${id}`,
  /**
   * @method POST batch upsert weights
   */
  weightsBatch: '/super-ranking/weights/batch',
  /**
   * @method GET list goals
   * @method POST create goal
   */
  goals: '/super-ranking/goals',
  /**
   * @method GET/PUT/DELETE single goal
   * @param {String} id goal UUID
   */
  goal: (id) => `/super-ranking/goals/${id}`,
  /**
   * @method POST batch upsert goals
   */
  goalsBatch: '/super-ranking/goals/batch',
  /**
   * @method GET list available functions for indicators
   */
  availableFunctions: '/super-ranking/available-functions',
  /**
   * @method GET list all professionals with their cluster assignments
   */
  professionalsClusters: '/super-ranking/professionals/clusters',
  /**
   * @method PUT assign cluster to a professional
   * @param {Number} idProf professional ID
   */
  professionalCluster: (idProf) => `/super-ranking/professionals/${idProf}/cluster`,
  /**
   * @method POST batch assign clusters to professionals
   */
  professionalsClustersBatch: '/super-ranking/professionals/clusters/batch',
  /**
   * @method GET list scores/pontuações
   * @param {String} ciclo_id optional cycle UUID to filter
   */
  scores: '/super-ranking/scores',
  /**
   * @method GET list scores resumo (agrupado por profissional)
   * @param {String} ciclo_id optional cycle UUID to filter
   */
  scoresResumo: '/super-ranking/scores/summary',
  /**
   * @method GET export ranking as Excel (gestor only)
   * @param {String} ciclo_id optional cycle UUID to filter
   */
  exportRanking: '/super-ranking/scores/export/ranking',
  /**
   * @method GET export detalhamento as Excel (gestor only)
   * @param {String} ciclo_id optional cycle UUID to filter
   */
  exportDetalhamento: '/super-ranking/scores/export/detalhamento',
}

// Blueprint `professional.py` no backend prefixa automaticamente todas
// as rotas com `/v2/api/professional/`. As rotas REGISTRADAS sao
// `/v2/api/professional/escritorio-open-finance/conexoes` etc.
const ESCRITORIO_OPEN_FINANCE_BASE =
  '/v2/api/professional/escritorio-open-finance'

export const openFinance = {
  /**
   * @method GET Lista conexões de Open Finance do escritório
   * @method POST Cria nova conexão
   * @param data {
   *   id_connector,
   *   credentials,
   *   instituicao_bancaria,
   *   codigo_banco,
   *   codigo_agencia,
   *   conta_corrente,
   *   id_bpo_conta_corrente?
   * }
   */
  conexoes: () => `${ESCRITORIO_OPEN_FINANCE_BASE}/conexoes`,
  /**
   * @method GET Detalhe de uma conexão
   * @method DELETE Remove uma conexão
   * @param id uuid da conexão
   */
  conexao: (id) => `${ESCRITORIO_OPEN_FINANCE_BASE}/conexoes/${id}`,
  /**
   * @method POST Atualiza saldo da conexão
   * @param id uuid da conexão
   */
  sincronizar: (id) =>
    `${ESCRITORIO_OPEN_FINANCE_BASE}/conexoes/${id}/sincronizar`,
  /**
   * @method POST Regenera o consentimento de uma conexão com autorização
   * revogada/expirada. Retorna value.consent_url (URL OAuth do banco)
   * quando o usuário precisa reautorizar.
   * @param id uuid da conexão
   */
  reconectar: (id) =>
    `${ESCRITORIO_OPEN_FINANCE_BASE}/conexoes/${id}/reconectar`,
}

export const atendimentoConexao = {
  /**
   * @method GET List connections visible to the current user
   * @method POST Create a new connection
   */
  conexoes: '/v2/api/atendimento/conexoes',
  /**
   * @method GET Bulk status check for all visible connections
   */
  status: '/v2/api/atendimento/conexoes/status',
  /**
   * @method POST Start the QR code connection flow
   * @param {Number} id_conexao
   */
  connect: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/connect`,
  /**
   * @method GET Get QR code for a connection
   * @param {Number} id_conexao
   */
  qrcode: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/qrcode`,
  /**
   * @method GET Get single connection status
   * @param {Number} id_conexao
   */
  statusSingle: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/status`,
  /**
   * @method POST Disconnect a connection
   * @param {Number} id_conexao
   */
  disconnect: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/disconnect`,
  /**
   * @method POST Restart a connection (fix session issues)
   * @param {Number} id_conexao
   */
  restart: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/restart`,
  /**
   * @method DELETE Delete a connection
   * @param {Number} id_conexao
   */
  deletar: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}`,
  /**
   * @method POST Update professional assignments for a connection
   * @method GET List professionals for a connection
   * @param {Number} id_conexao
   */
  profissionais: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/profissionais`,
  /** @method GET Get current terms text */
  termos: '/v2/api/atendimento/termos',
  /** @method POST Accept terms */
  termosAceitar: '/v2/api/atendimento/termos/aceitar',
}

export const anbimaClasses = {
  /**
   * @method GET Lista classes ANBIMA do escritório
   * @method POST Cria nova classe ANBIMA — body { classe_anbima }
   */
  list: '/v2/api/office/anbima/classes',
  /**
   * @method PUT Renomeia classe ANBIMA — concat /:id
   * @method DELETE Remove classe ANBIMA (bloqueado se referenciada) — concat /:id
   */
  byId: (id) => `/v2/api/office/anbima/classes/${id}`,
  /**
   * @method POST Faz seed das 9 classes default (idempotente)
   */
  provisionDefaults: '/v2/api/office/anbima/classes/provision-defaults',
  /**
   * @method GET Lista os valores distintos de classe_anbima já atribuídos aos ativos do escritório
   */
  classesAtivos: '/v2/api/office/anbima/classes-ativos',
}

export const anbimaClassMapping = {
  /**
   * @method GET Lista de-para classe interna → classe ANBIMA do escritório
   * @method POST Cria mapping — body { classe, classe_anbima }
   */
  list: '/v2/api/office/anbima/class-mapping',
  /**
   * @method PUT body { classe_anbima }
   * @method DELETE
   */
  byId: (id) => `/v2/api/office/anbima/class-mapping/${id}`,
  /**
   * @method POST Bulk upsert — body { items, delete_missing }
   * @returns value: { inserted, updated, deleted }
   */
  bulk: '/v2/api/office/anbima/class-mapping/bulk',
  /**
   * @method POST Reprocessa os ativos do escritório aplicando as regras de de-para
   */
  reprocess: '/v2/api/office/anbima/class-mapping/reprocess',
}

export const anbimaMaxAlocacao = {
  /**
   * @method GET Lista máximos por classe ANBIMA do perfil (id_composicao_estrategica)
   */
  list: '/v2/api/office/strategic-allocation/max',
  /**
   * @method POST Bulk upsert — body { id_composicao_estrategica, items, delete_missing }
   */
  save: '/v2/api/office/strategic-allocation/max',
}

export const anbimaAsset = {
  /**
   * @method POST Propaga classe_anbima do ativo para todos os clientes que o têm
   * @returns value: { n_affected, mode: 'sync' | 'async', trigger_recalc }
   */
  propagateClasseAnbima: (id_ativo) =>
    `/v2/api/office/asset/${id_ativo}/propagate-classe-anbima`,
}

export const mirroredAccess = {
  /**
   * Acesso espelhado: profissional comum que pode ver dados de outros profissionais
   * (BI, Financeiro, Comissionamento)
   *
   * @method GET Lista acessos espelhados
   * @method POST Cria novo acesso
   * @param {Object} data { id_profissional, id_profissional_acesso, nivel_acesso }
   */
  list: '/v2/api/aawz-partners/permissoes-acessos-profissional',
  /**
   * @method GET/PUT/DELETE acesso específico
   * @param {String} id permission UUID
   */
  byId: (id) => `/v2/api/aawz-partners/permissoes-acessos-profissional/${id}`,
  /**
   * @method POST Sincroniza acessos em batch
   * @param {Object} data { id_profissional: Number, ids_profissional_acesso: Array<Number>, nivel_acesso?: Number }
   */
  batch: '/v2/api/aawz-partners/permissoes-acessos-profissional/batch',
}
